import React, { createContext, useEffect, useState } from "react";
import { getSortedCollection } from "sprint-common-web";

import { GetDistributionListsLookupResponse } from "../../api/orders-api/order/GetDistributionListsLookupResponse";
import { useOrdersApi } from "../../api/orders-api/useOrdersApi";

interface IDistributionListsDataContent {
    distributionLists: DistributionList[];
    isLoading: boolean;
}

export interface DistributionList {
    id: number;
    name: string;
}

export const DistributionListsDataContent = createContext<IDistributionListsDataContent>(
    {} as IDistributionListsDataContent
);

type DistributionListsDataProviderProps = React.PropsWithChildren<unknown>;

export const DistributionListsDataProvider: React.FunctionComponent<DistributionListsDataProviderProps> = ({
    children
}: DistributionListsDataProviderProps) => {
    const [distributionLists, setDistributionLists] = useState<DistributionList[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const { getDistributionListsLookup } = useOrdersApi();

    useEffect(() => {
        setIsLoading(true);
        getDistributionListsLookup().then((response: GetDistributionListsLookupResponse) => {
            setDistributionLists(getSortedCollection(response.items, "name"));
            setIsLoading(false);
        });
    }, []);

    return (
        <DistributionListsDataContent.Provider value={{ distributionLists: distributionLists, isLoading }}>
            {children}
        </DistributionListsDataContent.Provider>
    );
};
